import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatoManutenzione } from '../models/stato-manutenzione';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class StatoManutenzioneService extends ResourcefulService<StatoManutenzione>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, StatoManutenzione);
    }

    async findByName(nome: string): Promise<StatoManutenzione | null> {
        try {
            const items = await this.getAll();
            return items.find(item => 
                item.nome?.toLowerCase() === nome.toLowerCase()
            ) || null;
        } catch (error) {
            console.error('Error finding StatoManutenzione by name:', error);
            return null;
        }
    }
}
